import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import withStyles from 'housecall-ui/dist/DesignSystem/Styles/withStyles';
import Box from 'housecall-ui/dist/DesignSystem/Layout/Box/Box';
import WarningOutlined from 'housecall-ui/dist/IconsAndImages/Icons/WarningOutlined';

const styles = (theme) => ({
  icon: {
    height: '60px',
    width: '60px',
    color: theme.palette.text.main,
  },
  blackPrimary: {
    color: theme.palette.text.main,
  },
});

const SomethingWentWrong = ({ classes }) => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    height="100vh"
  >
    <WarningOutlined
      color="alert"
      size="large"
      backgroundCircle
    />
    <Typography
      variant="h2"
      className={classes.blackPrimary}
      gutterBottom
    >
      Something went wrong
    </Typography>
    <Typography
      variant="body1"
      color="textSecondary"
      gutterBottom
    >
      Please reload your browser window.
    </Typography>
    <Typography
      variant="body1"
      color="textSecondary"
    >
      If the problem persists, please contact support using the blue chat bubble in the corner of the page.
    </Typography>
  </Box>
);

export default withStyles(styles)(SomethingWentWrong);
